import React from 'react';
import PageFade from '@/common/components/PageFade.tsx';
import { Outlet } from 'react-router-dom';
import PageHeader from '@/portal/components/PageHeader.tsx';

const ProvidersRoot: React.FC = () => {
  return (
    <PageFade>
      <PageHeader title="Providers" />
      <Outlet />
    </PageFade>
  );
};

export default ProvidersRoot;
